export default __webpack_public_path__ + "static/media/chest.fd1490f7.png";